module.exports = __webpack_public_path__ + "img/only-rightgirl.3f0f1941.svg";